import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedRequest = request.clone({
      setHeaders: {
        // 'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
        // Pragma: 'no-cache',
        // Expires: '0',

        'Access-Control-Allow-Origin': '*',
        'X-Frame-Options': 'SAMEORIGIN'
      },
    });

    return next.handle(modifiedRequest);
  }
}
